import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from '@common/composables'
    import { useResourcePage } from '@DataSharing/Shares/pages-core'
    import { copyToClipboard } from "@common/Common";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcePage',
  setup(__props) {

    document.title = 'Share data'

    const route = useRoute()
    const provider = route.params.provider

    const id = ref()
    const organizationUnitId = ref()
    const workspaceId = ref()
    const projectId = ref()
    const sharedBy = ref()
    const sharedWith = ref()
    const resourceProviderName = ref(provider)
    const resourceId = ref(route.params.resourceId)
    const emailsProviderName = ref()
    const emailsProviderConfig = ref()
    const copied = ref<string[]>([])

    const { useResourceSharesQuery } = useResourcePage()

    const { modelResourceSharesQueryV1, runResourceSharesQueryV1 } = useResourceSharesQuery(provider, resourceId.value)

    const shares = computed(() => modelResourceSharesQueryV1.value?.Shares || [])
    const isShared = computed(() => modelResourceSharesQueryV1.value && shares.value.length > 0)
    const newShareId = computed(() => modelResourceSharesQueryV1.value?.NewShareId)
    const organizationName = computed(() => modelResourceSharesQueryV1.value?.OrganizationUnitName)
    const workspaceName = computed(() => modelResourceSharesQueryV1.value?.WorkspaceName)
    const projectName = computed(() => modelResourceSharesQueryV1.value?.ProjectName)
    const resourceName = computed(() => modelResourceSharesQueryV1.value?.ResourceName)
    const resourceUrl = computed(() => modelResourceSharesQueryV1.value?.ResourceUrl)
    const manageUrl = computed(() => modelResourceSharesQueryV1.value?.ManageUrl)

    const sharesExt = computed(() => shares.value.map(_ => Object.assign({}, _, {
        Copied: copied.value.find(c => c == _.ShareId) != undefined
    })))

    function handleCopyToClipboard(share: any) {
        copyToClipboard(share.ShareUrl)
        copied.value.push(share.ShareId)

        const h = setTimeout(() => {{
            copied.value = copied.value.filter(_ => _ != share.ShareId)
            clearTimeout(h)
        }}, 1000)
    }

    onMounted(() => runResourceSharesQueryV1())

    watch(modelResourceSharesQueryV1, () => {
        const model = modelResourceSharesQueryV1.value
        id.value = model?.ShareId
        organizationUnitId.value = model?.OrganizationUnitId
        workspaceId.value = model?.WorkspaceId
        projectId.value = model?.ProjectId
        sharedBy.value = model?.AuthenticatedEmail
        emailsProviderName.value = model?.EmailsProviderName
        emailsProviderConfig.value = model?.EmailsProviderConfig
    })

    watch(isShared, () => {
        if (!isShared.value) {
            location.href = `/#/sharing/share/${resourceProviderName.value}/${resourceId.value}/${newShareId.value}`
        }
    })

return { __sfc: true,route, provider, id, organizationUnitId, workspaceId, projectId, sharedBy, sharedWith, resourceProviderName, resourceId, emailsProviderName, emailsProviderConfig, copied, useResourceSharesQuery, modelResourceSharesQueryV1, runResourceSharesQueryV1, shares, isShared, newShareId, organizationName, workspaceName, projectName, resourceName, resourceUrl, manageUrl, sharesExt, handleCopyToClipboard }
}

})